export default {
	back_to_intel_retail_edge_program: "Back to Intel® Retail Edge Program",
	other_names_and_brands_could_be_claimed_as_third_party_property: "Other names and brands could be claimed as third party property",
	trademarks: "Trademarks"
}
